var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1358_3541",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.492188,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1358_3541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4422 18C12.7922 18 13.088 17.8792 13.3297 17.6375C13.5714 17.3958 13.6922 17.1 13.6922 16.75C13.6922 16.4 13.5714 16.1042 13.3297 15.8625C13.088 15.6208 12.7922 15.5 12.4422 15.5C12.0922 15.5 11.7964 15.6208 11.5547 15.8625C11.313 16.1042 11.1922 16.4 11.1922 16.75C11.1922 17.1 11.313 17.3958 11.5547 17.6375C11.7964 17.8792 12.0922 18 12.4422 18ZM11.5422 14.15H13.3922C13.3922 13.6 13.4547 13.1667 13.5797 12.85C13.7047 12.5333 14.0589 12.1 14.6422 11.55C15.0755 11.1167 15.4172 10.7042 15.6672 10.3125C15.9172 9.92083 16.0422 9.45 16.0422 8.9C16.0422 7.96667 15.7005 7.25 15.0172 6.75C14.3339 6.25 13.5255 6 12.5922 6C11.6422 6 10.8714 6.25 10.2797 6.75C9.68802 7.25 9.27552 7.85 9.04219 8.55L10.6922 9.2C10.7755 8.9 10.963 8.575 11.2547 8.225C11.5464 7.875 11.9922 7.7 12.5922 7.7C13.1255 7.7 13.5255 7.84583 13.7922 8.1375C14.0589 8.42917 14.1922 8.75 14.1922 9.1C14.1922 9.43333 14.0922 9.74583 13.8922 10.0375C13.6922 10.3292 13.4422 10.6 13.1422 10.85C12.4089 11.5 11.9589 11.9917 11.7922 12.325C11.6255 12.6583 11.5422 13.2667 11.5422 14.15ZM12.4922 22C11.1089 22 9.80885 21.7375 8.59219 21.2125C7.37552 20.6875 6.31719 19.975 5.41719 19.075C4.51719 18.175 3.80469 17.1167 3.27969 15.9C2.75469 14.6833 2.49219 13.3833 2.49219 12C2.49219 10.6167 2.75469 9.31667 3.27969 8.1C3.80469 6.88333 4.51719 5.825 5.41719 4.925C6.31719 4.025 7.37552 3.3125 8.59219 2.7875C9.80885 2.2625 11.1089 2 12.4922 2C13.8755 2 15.1755 2.2625 16.3922 2.7875C17.6089 3.3125 18.6672 4.025 19.5672 4.925C20.4672 5.825 21.1797 6.88333 21.7047 8.1C22.2297 9.31667 22.4922 10.6167 22.4922 12C22.4922 13.3833 22.2297 14.6833 21.7047 15.9C21.1797 17.1167 20.4672 18.175 19.5672 19.075C18.6672 19.975 17.6089 20.6875 16.3922 21.2125C15.1755 21.7375 13.8755 22 12.4922 22ZM12.4922 20C14.7255 20 16.6172 19.225 18.1672 17.675C19.7172 16.125 20.4922 14.2333 20.4922 12C20.4922 9.76667 19.7172 7.875 18.1672 6.325C16.6172 4.775 14.7255 4 12.4922 4C10.2589 4 8.36719 4.775 6.81719 6.325C5.26719 7.875 4.49219 9.76667 4.49219 12C4.49219 14.2333 5.26719 16.125 6.81719 17.675C8.36719 19.225 10.2589 20 12.4922 20Z",
    fill: "#E9E9E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.50e341f0f601afebe79ab179ce69532a.svg";
export { ForwardRef as ReactComponent };